export default __webpack_public_path__ + "locales/vi/Files.json?hash=2f8f434b53cb58271b0110140d52173f";